const COURSE_TABS = {
  TAB_OVERVIEW: 'overview',
  TAB_TOC: 'table-of-content',
  TAB_CREDITS: 'credits',
};

export default COURSE_TABS;
